import config from "../../../config";
import { Spinner } from "react-bootstrap";
import arrowRight from "../../../assets/arrow-right-black.svg";
import "./AiRightPanel.css";

const AiRightPanel = ({
  loading,
  isOpen,
  setIsOpen = () => {},
  content = <></>,
}) => {
  return (
    <div
      className="right-panel-text-container"
      style={{
        right: isOpen ? 0 : -400,
        paddingTop: config.TOP_BAR_HEIGHT,
      }}
    >
      <img
        className="img-flip mt-16 ml--10 img-24"
        src={arrowRight}
        alt={"close"}
        onClick={() => setIsOpen(false)}
      ></img>
      {loading || !content ? (
        <div className="d-flex fvc vhc">
          <Spinner className="size-70" />
        </div>
      ) : (
        <div className="hide-scrollbar right-panel-scrollable">{content}</div>
      )}
    </div>
  );
};

export default AiRightPanel;
